import * as actions from '../actions/features'
import Immutable from 'seamless-immutable'
import {REHYDRATE} from 'redux-persist/constants'
import {APP_RESET_STATE} from '../actions/app'
import objectPath from 'object-path'

const initialState = Immutable({
	lastSeen: undefined
})

export default function (state = initialState, action){

	switch(action.type){

		case APP_RESET_STATE:
		case REHYDRATE:
			return state.merge({
				lastSeen: objectPath.get(action.payload, ['Features', 'lastSeen'], 0)
			})

		case actions.FEATURES_DONE_OR_SKIP:
			return state.set('lastSeen', action.lastSeen)

	}

	return state
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/reducers/features.js